import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../store';
import siteService from '../../services/sites';
import contactService from '../../services/contacts';
import concentrateurService from '../../services/concentrateurs';
import {
  SiteState,
  SiteSortValues,
  SitePayload,
  SiteContact,
  SiteConcentrateur,
  Concentrateur,
  Contact,
  ConcentrateurPayload,
  ConcentrateurState,
  ContactPayload,
  SiteFilterValues,
} from '../types';
import { addSite2Contact, addSite2LinkedContact, fetchContacts } from './contactsSlice';
import { fetchConcentrateursBySitesSn } from './concentrateursSlice';
import { notify } from './notificationSlice';
import { History } from 'history';
import { getErrorMsg } from '../../utils/helperFuncs';
import { fetchEquipementsForSiteSn } from './equipementsSlice';
//import { selectEquipementsBySiteSn } from './equipementsSlice';

interface InitialSitesState {
  sites: SiteState[];
//  contacts: {};
  fetchStatus: 'idle' | 'loading' | 'succeeded' | 'failed';
  fetchError: string | null;
  submitLoading: boolean;
  submitError: string | null;
  sortBy: SiteSortValues;
  filterBy: SiteFilterValues;
}

const initialState: InitialSitesState = {
  sites: [],
  fetchStatus: 'idle',
  fetchError: null,
  submitLoading: false,
  submitError: null,
  sortBy: 'sn-sites-asc',
  filterBy: 'running',
};

const sitesSlice = createSlice({
  name: 'sites',
  initialState,
  reducers: {
    setSites: (state, action: PayloadAction<SiteState[]>) => {
      state.sites = action.payload;
      state.fetchStatus = 'succeeded';
      state.fetchError = null;
    },
    addSite: (state, action: PayloadAction<SiteState>) => {
      state.sites.push(action.payload);
      state.submitLoading = false;
      state.submitError = null;
//      const ctct = action.payload.contacts
//      state.sites.push()
    },
    /*getSitesSn: (state, action: PayloadAction<string>) => {
      state.sites = state.sites.filter((s)=>s.sn_site === action.payload)
    },*/
    removeSite: (state, action: PayloadAction<string>) => {
      state.sites = state.sites.filter((p) => p.id !== action.payload);
    },
    replaceSiteState: (
      state,
      action: PayloadAction<{
        data: { updatedSite: SitePayload };
        siteId: string;
      }>
    ) => {
      state.sites = state.sites.map((p) =>
        p.id === action.payload.siteId ? { ...p, ...action.payload.data } : p
      );
      state.submitLoading = false;
      state.submitError = null;
    },
    updateSiteConcentrateursState: (
      state,
      action: PayloadAction<{ data: Concentrateur[]; siteId: string; }>
    ) => {
      let updSite: SiteState
      state.sites.map((p) => {
        if(p.id === action.payload.siteId) {
           updSite = p
           updSite.concentrateur = action.payload.data
        }
      });
      //TODO: moded to test :
      state.sites = state.sites.map((s) => s.id === action.payload.siteId ? { ...s, updSite } : s )
/*      state.sites.map((s) =>
        s.id === action.payload.siteId ? { ...s, ...action.payload.data } : s
      );*/
//      state.sites.find((s) => s.id === action.payload.siteId)?.concentrateur = action.payload.data
/*      state.sites = state.sites.map((p) =>
        p.id === action.payload.siteId ? { ...p, ...action.payload.data } : p
      );*/
      state.submitLoading = false;
      state.submitError = null;
    },
    updateSiteContact: (
      state,
      action: PayloadAction<{ data: Contact[]; siteId: string; }>
    ) => {
      let updSite: SiteState
      state.sites.map((p) => {
        if(p.id === action.payload.siteId) {
           updSite = p
           updSite.contacts = action.payload.data
        }
      });
      //TODO: moded to test :
      state.sites = state.sites.map((s) => s.id === action.payload.siteId ? { ...s, updSite } : s )
      state.submitLoading = false;
      state.submitError = null;
    },
    updateSiteState: (
      state,
      action: PayloadAction<{
        data: { updatedSite: SitePayload };
        siteId: string;
      }>
    ) => {
      /*if(action.payload.data.updatedSite.contacts !== undefined) {
        let updSite: SiteState
        state.sites.map((p) => {
          if(p.id === action.payload.siteId) {
            updSite = p
            updSite.contacts = action.payload.data.updatedSite.contacts?.slice(0)
          }
        });
        state.sites = state.sites.map((s) => s.id === action.payload.siteId ? { ...s, updSite } : s )
      }*/
      /*state.sites = state.sites.map((p) =>
        p.id === action.payload.siteId ? { ...p.contacts, ...action.payload.data.updatedSite.contacts } : p
      );*/
      state.sites = state.sites.map((s) => s.id === action.payload.siteId ? { ...s, ...action.payload.data.updatedSite } : s )
      /* TODO: previous 
      let updatedLgmt: SiteState
      state.sites.map((p) =>
        p.id === action.payload.siteId ? updatedLgmt = p : null 
      );
      state.sites = state.sites.filter((p) =>
        p.id !== action.payload.siteId
      );
      state.submitLoading = false;
      state.submitError = null;*/
    },
    updateSiteNote: (
      state,
      action: PayloadAction<{
        siteNote: string;
        siteId: string;
      }>
    ) => {
      let updSite: SiteState
      state.sites.map((p) => {
        if(p.id === action.payload.siteId) {
           updSite = p
           updSite.rq_instru = action.payload.siteNote
        }
      });
      state.sites = state.sites.map((s) => s.id === action.payload.siteId ? { ...s, updSite } : s ) 
      state.submitLoading = false;
      state.submitError = null;
    },
/*    addModule2conc: (
      state,
      action: PayloadAction<{
        siteId: string;
        concId: number;
        modSn: string;
      }>
    ) => {
      let updSite: SiteState
      state.sites.map((p) => {
        if(p.id === action.payload.siteId) {
          updSite = p
          let modz = p.concentrateur.find(c => c.id === Number(action.payload.concId))?.modules
          modz?.push(Number(action.payload.modSn))
          if (updSite.concentrateur.find((c) => c.id === Number(action.payload.concId))?.modules !== undefined) {
            updSite.concentrateur.find((c) => c.id === Number(action.payload.concId)).modules = modz 
          }
        }
      });
      state.sites = state.sites.map((s) => s.id === action.payload.siteId ? { ...s, updSite } : s ) 
      state.submitLoading = false;
      state.submitError = null;
    },*/
    updateSiteName: (
      state,
      action: PayloadAction<{
        data: { siteSn: string; date_update: Date };
        siteId: string;
      }>
    ) => {
      state.sites = state.sites.map((p) =>
        p.id === action.payload.siteId ? { ...p, ...action.payload.data } : p
      );
      state.submitLoading = false;
      state.submitError = null;
    },
    addContacts: (
      state,      
      action: PayloadAction<{ contacts: string; siteId: string }>
      //action: PayloadAction<{ contacts: SiteContact; siteId: string }>
    ) => {
/*      state.sites = state.sites.map((p) =>
        p.id === action.payload.siteId
          ? { ...p, contacts: action.payload.contacts }
          : p
      );
      state.submitLoading = false;
      state.submitError = null;*/
    },
    removeContact: (
      state,
      action: PayloadAction<{ contactId: string; siteId: string }>
    ) => {
      const site = state.sites.find(
        (p) => p.id === action.payload.siteId
      );
    /*
      if (site) {
        const updatedContacts = site.contacts.filter(
          (m) => m.contact.id !== action.payload.contactId
        );
        state.sites = state.sites.map((p) =>
          p.id === action.payload.siteId
            ? { ...p, contacts: updatedContacts }
            : p
        );
      }*/
    },
    addConcentrateurs: (
      state,
      action: PayloadAction<{ concentrateurs: /*Site*/Concentrateur[]; siteId: string }>
    ) => {
      state.sites = state.sites.map((p) =>
        p.id === action.payload.siteId
          ? { ...p, concentrateurs: action.payload.concentrateurs }
          : p
      );
      state.submitLoading = false;
      state.submitError = null;
    },
    removeConcentrateur: (
      state,
      action: PayloadAction<{ concentrateurId: string; siteId: string }>
    ) => {
      const site = state.sites.find(
        (p) => p.id === action.payload.siteId
      );
    },
    setFetchSitesLoading: (state) => {
      state.fetchStatus = 'loading';
      state.fetchError = null;
    },
    setFetchSitesError: (state, action: PayloadAction<string>) => {
      state.fetchStatus = 'failed';
      state.fetchError = action.payload;
    },
    setSubmitSiteLoading: (state) => {
      state.submitLoading = true;
      state.submitError = null;
    },
    setSubmitSiteError: (state, action: PayloadAction<string>) => {
      state.submitLoading = false;
      state.submitError = action.payload;
    },
    clearSubmitSiteError: (state) => {
      state.submitError = null;
    },
    sortSitesBy: (state, action: PayloadAction<SiteSortValues>) => {
      state.sortBy = action.payload;
    },
    filterSitesBy: (state, action: PayloadAction<SiteFilterValues>) => {
      state.filterBy = action.payload;
    },
  },
});

export const {
  setSites,
  addSite,
//  getSitesSn,
  removeSite,
  replaceSiteState,
  updateSiteNote,
  updateSiteName,
  updateSiteState,
  updateSiteContact,
  updateSiteConcentrateursState,
  addContacts,
  addConcentrateurs,
  removeContact,
  removeConcentrateur,
//  addModule2conc,
  setFetchSitesLoading,
  setFetchSitesError,
  setSubmitSiteLoading,
  setSubmitSiteError,
  clearSubmitSiteError,
  sortSitesBy,
  filterSitesBy,
} = sitesSlice.actions;

export const fetchSites = (): AppThunk => {
  return async (dispatch) => {
    try {
      dispatch(setFetchSitesLoading());
      const allSites = await siteService.getSites();
      dispatch(setSites(allSites));
    } catch (e) {
      //@ts-ignore
      dispatch(setFetchSitesError(getErrorMsg(e)));
    }
  };
};

export const createNewSite = (
  theContact: ContactPayload,
  siteData: SitePayload,
//  closeDialog?: () => void
): AppThunk => {
  return async (dispatch) => {
    try {
      dispatch(setSubmitSiteLoading());
      const newSite = await siteService.createSite(theContact, siteData);
      dispatch(addSite(newSite));
      dispatch(notify('Logement ajouté !', 'success'));
      //TODO: MàJ les contacts dans le state
      dispatch(addSite2LinkedContact({contactId: String(newSite.contacts[0].id), siteId: newSite.id}))
//      closeDialog && closeDialog();
      // TODO: renvoyer vers page d'accueil ? "on success"
    } catch (e) {
      //@ts-ignore
      dispatch(setSubmitSiteError(getErrorMsg(e)));
    }
  };
};

export const updateSite = (   // créé une nouvelle 'vue'
  siteId: string,
  siteData: SitePayload,
  //  siteSn: string,
  closeDialog?: () => void
): AppThunk => {
  return async (dispatch) => {
    try {
      dispatch(setSubmitSiteLoading());
      const updatedSite: SitePayload = await siteService.updateSite(siteId, siteData);
      if(updatedSite !== undefined && updatedSite?.contacts !== undefined) { 
        let burp: Contact[] = updatedSite.contacts
        dispatch(updateSiteState({data: {updatedSite}, siteId}))
        console.log('Infos logement mises à jour')
        dispatch(notify('Infos logement mises à jour', 'success')); 
      } else {
        dispatch(setSubmitSiteError(getErrorMsg(e)));
        dispatch(notify("Infos logement NON mises à jour :-(", 'success'));
      }
/*      const updatedSite: SiteState = await siteService.updateSite(siteId, siteData);
      dispatch(addSite(updatedSite))*/
      //TODO: MàJ les contacts dans le state
      dispatch(addSite2LinkedContact({contactId: String(updatedSite.contacts[0].id),siteId: updatedSite.id}))
      //dispatch(updateSiteState({data: {updatedSite},siteId}))
/*      dispatch(
        updateSiteName({
          data: {
            siteSn: updatedSite.siteSn,
            date_update: updatedSite.date_update,
          },
          siteId,
        })
      );*/
      dispatch(notify("Infos logement prises en compte !", 'success'));
      closeDialog && closeDialog();
    } catch (e) {
      //@ts-ignore
      dispatch(setSubmitSiteError(getErrorMsg(e)));
    }
  };
};

export const modifySite = ( // modifie un logement dont la vue est déjà existante
  siteId: string,
  siteData: SitePayload,
  //  siteSn: string,
  closeDialog?: () => void
): AppThunk => {
  return async (dispatch) => {
    try {
      dispatch(setSubmitSiteLoading());
      const updatedSite = await siteService.modifySite(siteId, siteData);
      dispatch(updateSiteState/*replaceSiteState*/({data: {updatedSite},siteId}))
/*      dispatch(
        updateSiteName({
          data: {
            siteSn: updatedSite.siteSn,
            date_update: updatedSite.date_update,
          },
          siteId,
        })
      );*/
      dispatch(notify("Infos logement prises en compte", 'success'));
      closeDialog && closeDialog();
    } catch (e) {
      //@ts-ignore
      dispatch(setSubmitSiteError(getErrorMsg(e)));
    }
  };
};

export const updateSiteConcentrateur = (   // créé une nouvelle 'vue'
  siteId: string,
  infos: { action: string, concSn: string, concentrateurSn: string, concentrateurId: string, dateChgmt: string, siteId: string, siteSn: string, tel: string, techno: string, modules: string },
  closeDialog?: () => void
): AppThunk => {
  return async (dispatch) => {
    try {
      dispatch(setSubmitSiteLoading());
      if(infos.action === 'stopConc') {
        const updatedConcs: ConcentrateurState[] = await siteService.stopConcentrateur(siteId, infos);
        const data: Concentrateur[] = []
        updatedConcs.map((uc) => {
          data.push({ id: Number(uc.id), tel: Number(uc.tel), date_start: uc.date_start || new Date(), date_end: uc.date_end || null, 
            date_last_data: uc.date_last_data || new Date(), ts_last_data: uc.ts_last_data || new Date(), pdt: 10, modules: uc.modules,
            alias_sn: uc.aliasSn, techno: uc.techno, version: uc.version, hardSn: Number(uc.hardSn), siteId: Number(uc.site_id), site_sn: Number(uc.site_sn) })
        })
        dispatch(updateSiteConcentrateursState({ data, siteId }))
      }
      if(infos.action === 'telConc') {
        const updatedConcs: ConcentrateurState[] = await siteService.telConcentrateur(siteId, infos);
        const data: Concentrateur[] = []
        updatedConcs.map((uc) => {
          data.push({ id: Number(uc.id), tel: Number(uc.tel), date_start: uc.date_start || new Date(), date_end: uc.date_end || null, 
            date_last_data: uc.date_last_data || new Date(), ts_last_data: uc.ts_last_data || new Date(), pdt: 10, modules: uc.modules,
            alias_sn: uc.aliasSn, techno: uc.techno, version: uc.version, hardSn: Number(uc.hardSn), siteId: Number(uc.site_id), site_sn: Number(uc.site_sn) })
        })
        dispatch(updateSiteConcentrateursState({ data, siteId }))
      }
      if(infos.action === 'addConc') {
        const updatedConcs: ConcentrateurState[] = await siteService.addConcentrateur(siteId, infos);
        const data: Concentrateur[] = []
        updatedConcs.map((uc) => {
          data.push({ id: Number(uc.id), tel: Number(uc.tel), date_start: uc.date_start || new Date(), date_end: null, 
            date_last_data: null /*uc.date_last_data || new Date()*/, ts_last_data: null /*uc.ts_last_data || new Date()*/, pdt: 10, modules: uc.modules,
            alias_sn: uc.aliasSn, techno: uc.techno, version: uc.version, hardSn: Number(uc.hardSn), siteId: Number(uc.site_id), 
            site_sn: /*state.sites.find((s) => s.id === uc.siteId).site_sn*/ Number(uc.site_sn) })
        })
        dispatch(updateSiteConcentrateursState({ data, siteId }))
      }
      if(infos.action === 'replaceConc') {
        const updatedConcs: ConcentrateurState[] = await siteService.replaceConcentrateur(siteId, infos);
        const data: Concentrateur[] = []
        updatedConcs.map((uc) => {
          data.push({ id: Number(uc.id), tel: Number(uc.tel), date_start: uc.date_start || new Date(), date_end: uc.date_end || null, 
            date_last_data: uc.date_last_data || null, ts_last_data: uc.ts_last_data || null, pdt: 10, modules: uc.modules,
            alias_sn: uc.aliasSn, techno: uc.techno, version: uc.version, hardSn: Number(uc.hardSn), siteId: Number(uc.site_id), site_sn: Number(uc.site_sn) })
        })
        dispatch(updateSiteConcentrateursState({ data, siteId }))
      }
      if(infos.action === 'updateConc') {     // modules, tel, wifi
        const updatedConcs: ConcentrateurState[] = await siteService.updateConcentrateur(siteId, infos);
        const data: Concentrateur[] = []
        updatedConcs.map((uc) => {
          data.push({ id: Number(uc.id), tel: Number(uc.tel), date_start: uc.date_start || new Date(), date_end: uc.date_end || null, 
            date_last_data: uc.date_last_data || null, ts_last_data: uc.ts_last_data || null, pdt: 10, modules: uc.modules,
            alias_sn: uc.aliasSn, techno: uc.techno, version: uc.version, hardSn: Number(uc.hardSn), siteId: Number(uc.site_id), site_sn: Number(uc.site_sn) })
        })
        dispatch(updateSiteConcentrateursState({ data, siteId }))
      }
      dispatch(notify("Infos concentrateurs/modules à jour!", 'success'));
      closeDialog && closeDialog();
    } catch (e) {
      //@ts-ignore
      dispatch(setSubmitSiteError(getErrorMsg(e)));
    }
  };
};

export const addModule = (
  siteId: string,
  concId: number,
  modSn: string,
  closeDialog?: () => void
): AppThunk => {
  return async (dispatch) => {
    try {
      const updatedConcs: ConcentrateurState[] = await siteService.addModule(siteId, concId, modSn);
      const data: Concentrateur[] = []
      updatedConcs.map((uc) => {
        data.push({ id: Number(uc.id), tel: Number(uc.tel), date_start: uc.date_start || new Date(), date_end: uc.date_end || null, 
          date_last_data: uc.date_last_data || new Date(), ts_last_data: uc.ts_last_data || new Date(), pdt: 10, modules: uc.modules,
          alias_sn: uc.aliasSn, techno: uc.techno, version: uc.version, hardSn: Number(uc.hardSn), siteId: Number(uc.site_id), site_sn: Number(uc.site_sn) })
      })
      dispatch(updateSiteConcentrateursState({ data, siteId }))
      /*
      dispatch(setSubmitSiteLoading());
      const newSite = await siteService.addModule(siteId, concId, modSn);
      dispatch(addModule2conc({siteId, concId, modSn}));*/
      dispatch(notify('Module ajouté', 'success'));
      closeDialog && closeDialog();
    } catch (e) {
      dispatch(setSubmitSiteError(getErrorMsg(e)));
    }
  };
};

export const replaceModule = (
  siteId: string,
  concId: number,
  prevModSn: string,
  newModSn: string,
  dateChgmt: string,
  siteSn: string,
  closeDialog?: () => void
): AppThunk => {
  return async (dispatch) => {
    try {
      const updatedConcs: ConcentrateurState[] = await siteService.replaceModule(siteId, concId, prevModSn, newModSn, dateChgmt, siteSn);
      const data: Concentrateur[] = []
      updatedConcs.map((uc) => {
        data.push({ id: Number(uc.id), tel: Number(uc.tel), date_start: uc.date_start || new Date(), date_end: uc.date_end || null, 
          date_last_data: uc.date_last_data || new Date(), ts_last_data: uc.ts_last_data || new Date(), pdt: 10, modules: uc.modules,
          alias_sn: uc.aliasSn, techno: uc.techno, version: uc.version, hardSn: Number(uc.hardSn), siteId: Number(uc.site_id), site_sn: Number(uc.site_sn) })
      })
      dispatch(updateSiteConcentrateursState({ data, siteId }))
      /*
      dispatch(setSubmitSiteLoading());
      const newSite = await siteService.addModule(siteId, concId, modSn);
      dispatch(addModule2conc({siteId, concId, modSn}));*/
      dispatch(notify('Module remplacé & voies ré-affectées', 'success'));
      closeDialog && closeDialog();
    } catch (e) {
      dispatch(setSubmitSiteError(getErrorMsg(e)));
    }
  };
};

export const stopModule = (
  siteId: string,
  concId: number,
  modSn: string,
  dateStop: string,
  siteSn: string,
  closeDialog?: () => void
): AppThunk => {
  return async (dispatch) => {
    try {
      const updatedConcs: ConcentrateurState[] = await siteService.stopModule(siteId, concId, modSn, dateStop, siteSn);
      const data: Concentrateur[] = []
      updatedConcs.map((uc) => {
        data.push({ id: Number(uc.id), tel: Number(uc.tel), date_start: uc.date_start || new Date(), date_end: uc.date_end || null, 
          date_last_data: uc.date_last_data || new Date(), ts_last_data: uc.ts_last_data || new Date(), pdt: 10, modules: uc.modules,
          alias_sn: uc.aliasSn, techno: uc.techno, version: uc.version, hardSn: Number(uc.hardSn), siteId: Number(uc.site_id), site_sn: Number(uc.site_sn) })
      })
      dispatch(updateSiteConcentrateursState({ data, siteId }))
      /*
      dispatch(setSubmitSiteLoading());
      const newSite = await siteService.addModule(siteId, concId, modSn);
      dispatch(addModule2conc({siteId, concId, modSn}));*/
      dispatch(notify('Module arrêté', 'success'));
      closeDialog && closeDialog();
    } catch (e) {
      dispatch(setSubmitSiteError(getErrorMsg(e)));
    }
  };
};

export const createNote = (
  siteId: string,
  siteData: { siteNote: string, date_update: string},
  closeDialog?: () => void
): AppThunk => {
  return async (dispatch) => {
    try {
      dispatch(setSubmitSiteLoading());
      const newSite = await siteService.createNote(siteId,siteData);
      dispatch(addSite(newSite));
      dispatch(notify('Note de suivi ajoutée', 'success'));
      closeDialog && closeDialog();
    } catch (e) {
      dispatch(setSubmitSiteError(getErrorMsg(e)));
    }
  };
};

export const updateNote = (
  siteId: string,
  siteData: { siteNote: string, date_update: string},
  closeDialog?: () => void
): AppThunk => {
  return async (dispatch) => {
    try {
      dispatch(setSubmitSiteLoading());
      const updatedSite = await siteService.updateNote(siteId,siteData);
      //dispatch(addSite(newSite));
//      dispatch(replaceSiteState({data : {updatedSite},siteId}))
      dispatch(updateSiteNote({siteNote: siteData.siteNote, siteId: siteId}))
      dispatch(notify('Note de suivi modifiée', 'success'));
      closeDialog && closeDialog();
    } catch (e) {
      dispatch(setSubmitSiteError(getErrorMsg(e)));
    }
  };
};

export const deleteSite = (
  siteId: string,
  history: History
): AppThunk => {
  return async (dispatch) => {
    try {
      await siteService.deleteSite(siteId);
      history.push('/');
      dispatch(removeSite(siteId));
      dispatch(notify('Deleted the site.', 'success'));
    } catch (e) {
      //@ts-ignore
      dispatch(notify(getErrorMsg(e), 'error'));
    }
  };
};


export const reloadSiteState = (
  siteId: string,
  closeDialog?: () => void
): AppThunk => {
  return async (dispatch) => {
    try {
      dispatch(setSubmitSiteLoading());
      const updatedSite = await siteService.getSiteBySiteId(siteId);
      dispatch(removeSite(siteId))
      dispatch(addSite(updatedSite))
      //dispatch(replaceSiteState({ data: {updatedSite}, siteId }));
      dispatch(notify('Logement mis à jour', 'success'));
      closeDialog && closeDialog();
    } catch (e) {
      //@ts-ignore
      dispatch(setSubmitSiteError(getErrorMsg(e)));
    }
  };
};

/*export const addSiteConcentrateurs = (  //Contacts
  siteId: string,
//  concentrateurs: Concentrateur[],
  concentrateurs: string[],
  closeDialog?: () => void
): AppThunk => {
  return async (dispatch) => {
    try {
      dispatch(setSubmitSiteLoading());
      const updatedConcentrateurs = await concentrateurService.addConcentrateurs(siteId, concentrateurs);
      dispatch(addConcentrateurs({ concentrateurs: updatedConcentrateurs, siteId }));
      dispatch(notify('New ceoncentrateur(s) added to the site!', 'success'));
      closeDialog && closeDialog();
    } catch (e) {
      //@ts-ignore
      dispatch(setSubmitSiteError(getErrorMsg(e)));
    }
  };
};*/

export const removeSiteContact = (
/*  siteId: string,
  contactId: string*/
  siteId: string, //number
  contactId: string // number
): AppThunk => {
  return async (dispatch) => {
    try {
      await contactService.removeContact(siteId, contactId);
 //     dispatch(removeContact({ contactId, siteId }));
      dispatch(notify('Removed the site contact.', 'success'));
    } catch (e) {
      //@ts-ignore
      dispatch(notify(getErrorMsg(e), 'error'));
    }
  };
};

export const removeSiteConcentrateur = (
/*  siteId: string,
  contactId: string*/
  siteId: string,
  concentrateurId: string
): AppThunk => {
  return async (dispatch) => {
    try {
      await concentrateurService.deleteConcentrateur(siteId, concentrateurId);
  //     dispatch(removeContact({ contactId, siteId }));
      dispatch(notify('Removed the site concentrateur.', 'success'));
    } catch (e) {
      //@ts-ignore
      dispatch(notify(getErrorMsg(e), 'error'));
    }
  };
};

export const leaveSiteContactship = (
  siteId: string,
  history: History
): AppThunk => {
  return async (dispatch) => {
    try {
      await contactService.leaveSite(siteId);
      history.push('/');
      dispatch(removeSite(siteId));
      dispatch(notify('Successfully left the site contactship!', 'success'));
    } catch (e) {
      //@ts-ignore
      dispatch(notify(getErrorMsg(e), 'error'));
    }
  };
};

export const selectSitesState = (state: RootState) => state.sites;

export const selectSitesStateBySn = (state: RootState, siteSn: string) => {
  fetchSitesBySn(siteSn);
  console.log("Asked: sites ["+siteSn+"]");
  return /*state.sites.sites = */state.sites.sites.filter((s) => s.sn_site === siteSn);
//  return state.sites = state.sites.filter((p) => p.id !== action.payload);
};

export const selectSiteById = (state: RootState, siteId: string) => {
//  console.log("Nb sites dans le state: "+state.sites.sites.length)
//  console.log("ID ["+siteId+"] logement demandé (slice): "+state.sites.sites.filter((p) => p.id === siteId)?.length)
  /*return state.sites.sites.find((p) => p.id === siteId) !== undefined ?
    state.sites.sites.find((p) => p.id === siteId)
    : state.sites.sites.slice()[0]*/
  return state.sites.sites.find((p) => p.id === siteId)
};

export const selectSiteBySn = (state: RootState, siteSn: string) => {
  //  console.log("Nb sites dans le state: "+state.sites.sites.length)
  //  console.log("ID ["+siteId+"] logement demandé (slice): "+state.sites.sites.filter((p) => p.id === siteId)?.length)
    return state.sites.sites.sort((a,b) => Number(b.id) - Number(a.id)).find((p) => p.sn_site === siteSn);
};

export const fetchSiteBySiteId = (siteId: string): AppThunk => {
  return async (dispatch) => {
    try {
      dispatch(setFetchSitesLoading());
      const site = await siteService.getSiteBySiteId(siteId);
      dispatch(setSites(site));
   //   dispatch(setEquipementsBySitesSn({ equipements: equipements, siteSn }));
    } catch (e) {
      dispatch(setFetchSitesError(getErrorMsg(e)));
    }
  };
};

export const fetchSitesBySn = (siteSn: string): AppThunk => {
  return async (dispatch) => {
    try {
      dispatch(setFetchSitesLoading());
      const sitesBySn = await siteService.getSitesBySn(siteSn);
      dispatch(setSites(sitesBySn));
      //dispatch(setSites(sitesBySn));
      dispatch(fetchContacts());
      dispatch(fetchConcentrateursBySitesSn(siteSn));
      dispatch(fetchEquipementsForSiteSn(siteSn));
      console.log("getSitesBySn");
    } catch (e) {
      dispatch(setFetchSitesError(getErrorMsg(e)));
    }
  };
};

export const selectSiteBySiteId = (state: RootState, siteId: string/*, siteSn: string*/) => {
//  return state.equipements.equipements?.[siteSn];
// foreach on equipement<array>, return array of equipements ...
  console.log("grrrr before fetchSite...")
  fetchSiteBySiteId(siteId/*, siteSn*/);    // TEST

  console.log("selectSiteBySiteIdSn siteSlice " + siteId/* + " " + siteSn*/);
//  fetchEquipementsBySitesSn(siteSn);
//  return state.equipements.equipements[siteSn];     // apparently GOOD
  return state.sites.sites?.filter((s) =>
    s.id === siteId
  );
//  return state.equipements.equipements?.[siteSn];     // TEST !!!

//  return state.equipements.equipements.setEquipementsBySitesSn(state, siteSn);
  //.gefilterBy((s) => s.sn_site == sn_site);
};

export const selectSitesBySn = (state: RootState, siteSn: string/*, siteSn: string*/) => {
//TODO: c'était celui là au 18/03/25    fetchSitesBySn(siteSn)
  console.log("grrrr selectSitesBySn ... "+siteSn+" / nombre trouvé : "+state.sites.sites.filter((s) => Number(s.sn_site) === Number(siteSn)).length)
//TODO: c'était celui là au 18/03/25  return state.sites.sites  //.filter((s) => s.sn_site.includes(siteSn))
    return state.sites.sites.filter((s) => Number(s.sn_site) === Number(siteSn)).sort((a,b) => Number(b.id) - Number(a.id))
};

/*export const selectMostRecentSitesBySn = (state: RootState, siteSn: string) => {
  //TODO: c'était celui là au 18/03/25    fetchSitesBySn(siteSn)
    console.log("grrrr selectSitesBySn ... "+siteSn+" / nombre trouvé : "+state.sites.sites.filter((s) => Number(s.sn_site) === Number(siteSn)).length)
  //TODO: c'était celui là au 18/03/25  return state.sites.sites  //.filter((s) => s.sn_site.includes(siteSn))
      return state.sites.sites.filter((s) => Number(s.sn_site) === Number(siteSn))
};*/
  
export const selectSitesBySiteSn = (state: RootState, siteSn: string) => {
  fetchSitesBySn(siteSn);    // TEST
  console.log("selectSitesBySiteSn slice " + siteSn);
  //  fetchEquipementsBySitesSn(siteSn);
  //  return state.equipements.equipements[siteSn];     // apparently GOOD
  return state.sites.sites;     // renvoi tous les sites OKAY
  //return state.sites.sites.filter((s)=>s.sn_site === siteSn);     // TODO: PÉTÉ
};
    
/*export const selectSitesBySn = (siteSn: string,
  ): AppThunk => {
    console.log("selectSitesBySn AppThunk sitesSlice");
    return (dispatch) => {
      dispatch(fetchSitesBySn(siteSn));
      dispatch(fetchEquipementsForSiteSn(siteSn));
      dispatch(fetchContacts());
//      dispatch(fetchConcentrateursBySitesSn('100107'));
    }
// OKAY  return state.sites.sites.filter((s) => s.sn_site == sn_site);
//    return state.sites.sites.find((s) => s.sn_site == sitesIdList);
  };
*/
  export const viewSiteSn = (
    siteSn: string,
  ): AppThunk => {
    console.log("viewSiteSn AppThunk sitesSlice");
    return (dispatch) => {
      dispatch(fetchSitesBySn(siteSn));
      dispatch(fetchEquipementsForSiteSn(siteSn));
      dispatch(fetchContacts());
//      dispatch(fetchConcentrateursBySitesSn('100107'));
    }
  };

  export const updateLegendes = ( siteSn: string, ): AppThunk => {
      const res = siteService.updateLegendes(siteSn)
      console.log("server response: "+res)
      return (dispatch) => { dispatch(notify('Les légendes seront mises à jour dans un instant', 'success')); }
  }
export default sitesSlice.reducer;
